import React from 'react';
import { BiError } from 'react-icons/bi';
import BlogCard from './BlogCard';
import BlogPagination from './BlogPagination';
import FadeInAnimation from '../Common/FadeInAnimation';
import { useTranslations } from '../../locales/useTranslations';

const BlogList = ({
    posts,
    currentPage,
    totalPages,
    onPageChange,
    isLoading = false,
    hasError = false
}) => {
    const { t } = useTranslations();

    return (
        <section className="blog-list-section">
            <div className="container">
                {isLoading ? (
                    <div className="blog-list-loading">
                        <div className="blog-loading-spinner" />
                        <p className="blog-loading-text">
                            {t('blog_loading')}
                        </p>
                    </div>
                ) : hasError || posts.length === 0 ? (
                    <FadeInAnimation direction="up" delay={100}>
                        <div className="blog-list-empty">
                            <div className="blog-empty-icon">
                                <BiError />
                            </div>
                            <h3 className="blog-empty-title">
                                {t('blog_unavailable_title')}
                            </h3>
                            <p className="blog-empty-text">
                                {t('blog_unavailable_message')}
                            </p>
                        </div>
                    </FadeInAnimation>
                ) : (
                    <>
                        <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {posts.map((post, index) => (
                                <div key={post.slug || post.id} className="col-lg-4 col-md-6 mb-4" style={{ display: 'flex' }}>
                                    <FadeInAnimation direction="up" delay={100 + (index * 50)} style={{ display: 'flex', width: '100%' }}>
                                        <BlogCard post={post} />
                                    </FadeInAnimation>
                                </div>
                            ))}
                        </div>

                        <BlogPagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={onPageChange}
                        />
                    </>
                )}
            </div>
        </section>
    );
};

export default BlogList;
